module.exports = __webpack_public_path__ + "static/media/shapes_02.a3db0a7f.svg";